import SourceStore from './SourceStore';
import ThreeDSecureStore from './ThreeDSecureStore';

export default class RootStore {
  constructor() {
    this.source = new SourceStore();
    this.threeDSecure = new ThreeDSecureStore();
  }
}
